import {
  GET_AUTO_REPORT_PRODUCT_LIST_URL,
  getAutoReportConfig,
  getAutoReportProductList,
} from 'src/clients';
import useSWR from 'swr';

export const useAutoReportData = (havePermission: boolean) => {
  const { data, ...swr } = useSWR(
    [GET_AUTO_REPORT_PRODUCT_LIST_URL, havePermission],
    havePermission
      ? () => getAutoReportProductList().then(res => res.data.data)
      : null,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
    },
  );

  return { data, ...swr };
};

export const useOldAutoReportData = (isUsingOldData: boolean) => {
  const { data, ...swr } = useSWR(
    isUsingOldData ? ['/reports/account-statement/scheduler'] : null,
    () => getAutoReportConfig().then(res => res.data.data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
    },
  );

  return { data, ...swr };
};
